import React from 'react';

const SliderPreviewImageMore = ({ item }) => {
  return (
    <div className="mt-2">
      {item.description && <div className="caption">{item.description}</div>}
      {item.rights && <div className="mt-2 caption">{item.rights}</div>}
    </div>
  );
};

export default SliderPreviewImageMore;
